import { IIssueApi } from "@schemas/issueSchema";
import { ColDef } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import React from "react";
import { CopyIssueButton } from "../../../../../../components";
import ConnectedTaskDeleteCell from "../../Table/ConnectedTaskDeleteCell";
import { getIssueActionNameOption } from "../../../issueUtils";
import { IOtherAttributeConfigApi } from "@schemas/otherAttributesSchema";
import { getAgGridOtherAttributeColumns } from "./issueOtherAttributeColumns";
import { IssueTableColumnContext } from "./issueTableColumnContext";

const CONNECTED_TASK_FIELDS = [
  "id",
  "title",
  "assignedTo.name",
  "status",
  "dates.due",
  "dates.started",
  "dates.completed",
];

export const getConnectedTaskColumns = ({
  baseColumns,
  columnContext,
  otherAttributesTasksConfig,
}: {
  baseColumns: ColDef<IIssueApi>[];
  columnContext: IssueTableColumnContext;
  otherAttributesTasksConfig: IOtherAttributeConfigApi;
}): ColDef<IIssueApi>[] => {
  const disabledColumnsTasks = columnContext.issueBoard?.disabledColumnsTasks ?? [];
  const columnsWithCopy = baseColumns
    .filter((col) => CONNECTED_TASK_FIELDS.includes(col?.field))
    .filter((col) => !disabledColumnsTasks.includes(col.field));

  const createCopyColumn: ColDef<IIssueApi> = {
    field: "_id",
    headerName: "Lag kopi",
    width: 90,
    minWidth: 90,
    suppressMovable: true,
    resizable: false,
    sortable: false,
    cellClass: "grid-display-block",
    cellRenderer: (params: CustomCellRendererProps<IIssueApi>) => (
      <div className="">
        <CopyIssueButton issue={params.data} taskOrIssue={"TASK"} />
      </div>
    ),
  };

  const createDeleteColumn: ColDef<IIssueApi> = {
    field: "_id",
    headerName: "Slett",
    width: 72,
    minWidth: 72,
    suppressMovable: true,
    resizable: false,
    sortable: false,
    cellClass: "grid-display-block",
    cellRenderer: (params: CustomCellRendererProps<IIssueApi>) => (
      <ConnectedTaskDeleteCell
        task={params.data}
        projectId={columnContext.projectId}
        taskDefiniteLabel={getIssueActionNameOption(columnContext.issueBoard?.taskNameSetting, "definite") ?? "Aksjonen"}
        controlSize={32}
        iconSize={20}
      />
    ),
  };

  const createReorderColumn: ColDef<IIssueApi> = {
    headerName: "",
    width: 40,
    minWidth: 40,
    maxWidth: 40,
    rowDrag: true,
    suppressMovable: true,
    sortable: false,
    resizable: false,
    pinned: "left",
    cellClass: "ag-row-drag",
  };

  const otherAttributeTasksColumns = getAgGridOtherAttributeColumns({
    columnContext,
    isTaskColumns: true,
    otherAttributesConfig: otherAttributesTasksConfig,
  }) as ColDef<IIssueApi>[];

  return [
    createReorderColumn,
    ...columnsWithCopy,
    ...otherAttributeTasksColumns,
    createCopyColumn,
    ...(columnContext.issueBoard?.disableDeleteIssue === true ? [] : [createDeleteColumn]),
  ];
};
